import { Box } from "@drone-js/core";
import { SEO } from "apps/commons/components/SEO";
import { partnerMarketingBinder } from "libs/analytics/binders/partnerMarketing";
import { useAnalytics } from "libs/analytics/useAnalytics";
import type { FunctionComponent } from "react";
import { AllYouHaveToDo } from "./AllYouHaveToDo";
import { ContactUs } from "./ContactUs";
import { Faqs } from "./Faqs";
import { FooterBottom } from "./FooterBottom";
import { FooterSiteMap } from "./FooterSiteMap";
import { HeroSection } from "./HeroSection";
import { Navbar } from "./Navbar";
import { WhyAgodaSection } from "./WhyAgodaSection";
import { usePartnerMarketingModelValue } from "./partnerMarketingModelAtom";

export const PartnerMarketingPage: FunctionComponent = () => {
    const { metaTitle, metaDescription } = usePartnerMarketingModelValue();

    useAnalytics(partnerMarketingBinder);
    return (
        <div className="partner-marketing" data-element-name="partner-marketing-container">
            <SEO title={metaTitle} description={metaDescription} />
            <Box textColor="base.default">
                <Navbar />
                <HeroSection />
                <AllYouHaveToDo />
                <WhyAgodaSection />
                <Faqs />
                <ContactUs />
                <FooterSiteMap />
                <FooterBottom />
            </Box>
        </div>
    );
};
